<template>
  <header class="header">
    <div class="container header__container">
      <div class="header__logo">
        <img src="/assets/reffal-logo.png" alt="reffal" class="logo-image" />
      </div>
      <nav class="header__nav">
        <button class="btn btn-register font-inter" @click="scrollToForm">
          Register
        </button>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  methods: {
    scrollToForm() {
      const formElement = document.querySelector('.waitlist-section')
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.header {
  background: var(--color-white);
  border-bottom: 1px solid var(--color-gray-200);
  padding: var(--space-4) 0;
  position: sticky;
  top: 0;
  z-index: 50;
}

.header__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-image {
  height: 32px;
  width: auto;
  display: block;
}

.btn-signin {
  background-color: var(--color-white);
  color: var(--color-primary);
  border: 1px solid var(--color-primary-light);
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius);
  font-weight: 500;
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-signin:hover {
  background-color: var(--color-gray-50);
}

.btn-register {
  background-color: var(--color-primary);
  color: var(--color-white);
  border: 1px solid var(--color-primary);
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius);
  font-weight: 500;
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-register:hover {
  background-color: var(--color-primary-dark);
}

.header__nav {
  display: flex;
  gap: var(--space-4);
}

@media (max-width: 768px) {
  .header__container {
    flex-direction: column;
    gap: var(--space-4);
  }
  
  .header__nav {
    width: 100%;
    justify-content: center;
  }
}
</style>
